import API from './index';

const api = {
    createApplicationDraft(data) {
        return API.authAPI({
            url: '/application/new-application',
            method: 'POST',
            data,
        });
    },
    cloneApplicationDraft(applicationFormId, data) {
        return API.authAPI({
            url: `/application/cloneNew-application/${applicationFormId}`,
            method: 'POST',
            data,
        });
    },

    getApplication({ page, pageSize, sort, isDesc, folder }) {
        return API.authAPI({
            url: '/application/get-application-list',
            method: 'POST',
            data: {
                page,
                pageSize,
                sort,
                isDesc,
                folder,
            },
        });
    },
    getApplicationHistory(id) {
        return API.authAPI({
            url: '/application/application-history/' + id,
            method: 'GET',
        });
    },
    getApplicationDetail({ id }) {
        return API.authAPI({
            url: '/application/get-detail-application/' + id,
            method: 'GET',
        });
    },
    saveApplicationDetail({ id, data, comment, action = 'save', actionType }) {
        return API.authAPI({
            url: '/application/save-detail-application/' + id,
            method: 'PATCH',
            data: {
                ...data,
                comment,
                action,
                actionType,
            },
        });
    },
    notifyCIForSubmissionApplication({ siteInfoId, applicationFormId, role, involvesSpecialCases }) {
        return API.authAPI({
            url: '/application/save-detail-application/' + applicationFormId,
            method: 'PATCH',
            data: {
                siteInfo: [
                    {
                        id: siteInfoId,
                        involvesSpecialCases,
                    },
                ],
                action: 'send',
            },
            params: {
                role,
            },
        });
    },
    updateApplicationDetail({ id, data, action = 'update' }) {
        return API.authAPI({
            url: '/application/update-application-status/' + id,
            method: 'PATCH',
            data: {
                ...data,
                action,
            },
        });
    },
    updateApplicationStatusWithDetail({ id, detail, ...rest }) {
        return API.authAPI({
            url: '/application/update-status-with-detail/' + id,
            method: 'POST',
            data: { ...detail, ...rest },
        });
    },
    getComment({ id }) {
        return API.authAPI({
            url: `/application/get-comment/${id}`,
            method: 'GET',
        });
    },
    changeExpiryDate({ data }) {
        return API.authAPI({
            url: `/application/change-expiry-date`,
            method: 'POST',
            data,
        });
    },
    consolidationConfirm({ id, data }) {
        return API.authAPI({
            url: `/application/consolidation-confirm/${id}`,
            method: 'POST',
            data,
        });
    },
    resumeSite(id) {
        return API.authAPI({
            url: `/application/resume-site/${id}`,
            method: 'POST',
        });
    },
    checkApplicationStatus(id) {
        return API.authAPI({
            url: `/application/check-application-status/${id}`,
            method: 'GET',
        });
    },
    getDelegation(id) {
        return API.authAPI({
            url: `/application/get-delegations/${id}`,
            method: 'GET',
        });
    },
    saveDelegation({ id, data }) {
        return API.authAPI({
            url: `/application/save-delegation/${id}`,
            method: 'PATCH',
            data: data,
        });
    },
    removeSite(siteInfoId, endEffectiveDate) {
        return API.authAPI({
            url: `/application/remove-site/${siteInfoId}`,
            method: 'PATCH',
            data: {
                endEffectiveDate,
            },
        });
    },
    viewApprovalLetter({ id }) {
        return API.authAPI({
            url: `/application/view-approval-letter/${id}`,
            method: 'GET',
        });
    },
    saveReuploadApprovalLetter({ id, data }) {
        return API.authAPI({
            url: `/application/save-reupload-approval-letter/${id}`,
            method: 'POST',
            data: data,
        });
    },
};

export default api;
